import {Avatar, Box, Button, Slider, Stack, Typography} from "@mui/material";
import {resizeImage} from "../../Utils/imageUtils";

const BulleSlide = {
    '& .MuiSlider-valueLabel': {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: '20px',
        height: '20px',
        width: '50px',
        fontSize: '12px'
    }
};

const sliderValueLabelPercent = (value) => `${value} %`;

export const DEFAULT_LOGO_FIELD = {logo: null, logoSize: 0.25};

/**
 * Import de logo + taille du logo, contrôlé : value = {logo: base64|null, logoSize: number (0-1)}.
 * Réutilisé par QrStyleForm (génération) et l'éditeur de palette.
 */
function LogoField({value, onChange}) {
    const {logo, logoSize} = {...DEFAULT_LOGO_FIELD, ...value};
    const logoSizePercent = Math.round(logoSize * 100);

    const handleLogoChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const base64 = await resizeImage(file);
            onChange({logo: base64, logoSize});
        } catch (error) {
            console.error('Erreur lors du traitement du logo:', error);
            alert('Erreur lors du traitement du logo');
        }
    };

    const handleRemove = () => onChange({logo: null, logoSize});

    return (
        <Box width="100%" display="flex" flexDirection="column" gap={2}>
            <Typography variant="caption" color="text.secondary">
                Formats acceptés : PNG, JPG, SVG. L'image sera automatiquement redimensionnée.
            </Typography>

            <Button variant="outlined" component="label" sx={{alignSelf: 'flex-start'}}>
                Importer un logo
                <input hidden accept="image/*" type="file" onChange={handleLogoChange}/>
            </Button>

            {logo && (
                <>
                    <Box display="flex" alignItems="center" gap={2}>
                        <Avatar src={logo} alt="Logo preview" variant="rounded" sx={{width: 100, height: 100}}/>
                        <Button variant="outlined" color="error" size="small" onClick={handleRemove}>
                            Supprimer
                        </Button>
                    </Box>

                    <Box width="100%">
                        <Typography variant="caption" color="text.secondary" sx={{mb: 0.5, display: 'block'}}>
                            Taille du logo
                        </Typography>
                        <Stack direction="row" spacing={2} sx={{alignItems: 'center'}}>
                            <Slider
                                sx={BulleSlide}
                                value={logoSizePercent}
                                aria-label="Taille du logo"
                                valueLabelDisplay="auto"
                                min={15}
                                max={40}
                                onChange={(e) => onChange({logo, logoSize: e.target.value / 100})}
                                valueLabelFormat={sliderValueLabelPercent}
                            />
                            <Box sx={{bgcolor: 'primary.main', borderRadius: '20px', width: '60px', textAlign: 'center'}}>
                                <Typography sx={{color: 'primary.contrastText'}}>{logoSizePercent} %</Typography>
                            </Box>
                        </Stack>
                    </Box>
                </>
            )}
        </Box>
    );
}

export default LogoField;
